import { render, staticRenderFns } from "./viewstock.vue?vue&type=template&id=885a95c0&"
import script from "./viewstock.vue?vue&type=script&lang=js&"
export * from "./viewstock.vue?vue&type=script&lang=js&"
import style0 from "./viewstock.vue?vue&type=style&index=0&id=885a95c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports